import * as tenancyScheduleTableColumns from "../actions/tenancy-schedule-table-columns";
import { IColumnDefinition } from "../../common/models/column-definition";
import { createEntityAdapter } from "@ngrx/entity"
import { EntityState } from "@ngrx/entity"

export interface State extends EntityState<TenancyScheduleColumnInstance> {
  availableColumns: IColumnDefinition[],
  error: string,
  loading: boolean,
}

export class TenancyScheduleColumnInstance {
  id: string;     
  availableColumns: IColumnDefinition[];
  error: string;
  loading: boolean;
}

export const tenancyScheduleWidgetColumnAdapter = createEntityAdapter<TenancyScheduleColumnInstance>();

export const INITIAL_STATE: State = tenancyScheduleWidgetColumnAdapter.getInitialState({
  availableColumns: undefined,
  error: undefined,
  loading: false,
});


export function reducer(state: State = INITIAL_STATE, action: tenancyScheduleTableColumns.Actions): State {
  switch (action.type) {
    case tenancyScheduleTableColumns.LOAD:
      {
        if ((<Array<string>>state.ids).indexOf(action.widget.id.toString()) !== -1) {
          return tenancyScheduleWidgetColumnAdapter.updateOne({ id: action.widget.id.toString(), changes: { loading: true } }, state);
        }

        return tenancyScheduleWidgetColumnAdapter.addOne({
          id: action.widget.id.toString(),
          loading: true,
          error: null,
          availableColumns: undefined
        }, state);
      }
    case tenancyScheduleTableColumns.LOAD_ALL:
    {
      return {
        ...state,
        loading: true
      };
      }
    case tenancyScheduleTableColumns.LOAD_ALL_COMPLETE:
    {
      return {
        ...state,
        availableColumns: action.payload,
        error: null,
        loading: false
      };
    }

    case tenancyScheduleTableColumns.LOAD_ALL_ERROR:
    {
      var errorMessage = null;
      if (action.payload.hasOwnProperty('message')) {
        errorMessage = action.payload.message;
      }
      return {
        ...state,
        error: errorMessage,
        loading: false,
        availableColumns: undefined,
      };
    }
    case tenancyScheduleTableColumns.LOAD_COMPLETE:
      {
        
        if ((<Array<string>>state.ids).indexOf(action.widget.id.toString()) !== -1) {
          return tenancyScheduleWidgetColumnAdapter.updateOne({
            id: action.widget.id.toString(), changes: {
              id: action.widget.id.toString(), loading: false,
              availableColumns: action.payload
            }
          }, state);
        }
        return tenancyScheduleWidgetColumnAdapter.addOne({
          id: action.widget.id.toString(), loading: false, error: null, availableColumns: action.payload
        }, state);
      }

    case tenancyScheduleTableColumns.LOAD_ERROR:
      {
        let errorMessage = null;
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        if (typeof state.ids[action.widget.id.toString()] === 'undefined') {
          return tenancyScheduleWidgetColumnAdapter.updateOne({ id: action.widget.id.toString(), changes: { error: errorMessage } }, state);
        }
        return state;
      }
    default:
      {
        return state;
      }
  }

}

